//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 部门间交易查询列表
const departmentBusinessList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/departmentBusiness/list.vue')),
    'departmentBusinessList'
  );
// 部门间交易新增
const departmentBusinessAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/departmentBusiness/add.vue')),
    'departmentBusinessAdd'
  );
// 部门间交易编辑
const departmentBusinessEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/departmentBusiness/edit.vue')),
    'departmentBusinessEdit'
  );

const departmentBusinessRouter = {
  path: '/departmentBusiness',
  component: index,
  children: [
    {
      path: 'list',
      name: 'departmentBusinessList',
      component: departmentBusinessList,
      meta: {
        keepAlive: true,
        title: '部门间交易列表',
      },
    },
    {
      path: 'add',
      name: 'departmentBusinessAdd',
      component: departmentBusinessAdd,
      meta: {
        keepAlive: true,
        title: '新建部门间交易',
      },
    },
    {
      path: 'edit',
      name: 'departmentBusinessEdit',
      component: departmentBusinessEdit,
      meta: {
        keepAlive: true,
        title: '编辑部门间交易',
      },
    },
  ],
};
export default departmentBusinessRouter;
